/*
 * This library originates from https://github.com/ifad/data-confirm-modal/blob/master/vendor/assets/javascripts/data-confirm-modal.js
 * It was modified to serve the same purpose with TailwindCSS and StimulusJS instead of Bootstrap.
 */
(function($) {
  /**
   * Builds the markup for a [Bootstrap modal](http://twitter.github.io/bootstrap/javascript.html#modals)
   * for the given `element`. Uses the following `data-` parameters to
   * customize it:
   *
   *  * `data-confirm`: Contains the modal body text. HTML is allowed.
   *                    Separate multiple paragraphs using \n\n.
   *  * `data-commit`:  The 'confirm' button text. "Confirm" by default.
   *  * `data-cancel`:  The 'cancel' button text. "Cancel" by default.
   *
   * You can set global setting using `dataConfirmModal.setDefaults`, for example:
   *
   *    dataConfirmModal.setDefaults({
   *      title: 'Confirm your action',
   *      commit: 'Continue',
   *      cancel: 'Cancel',
   *      fade:   false,
   *    });
   *
   */

  const defaults = {
    title: 'Are you sure?',
    commit: 'Confirm',
    commitClass: 'c-button',
    cancel: 'Cancel',
    cancelClass: 'c-button c-button--type-tertiary',
    fade: true,
    elements: ['a[data-confirm]', 'button[data-confirm]', 'input[type=submit][data-confirm]'],
    zIndex: 1050,
    modalClass: false,
    modalCloseContent: '&times;'
  }

  let settings

  window.dataConfirmModal = {
    setDefaults: function(newSettings) {
      settings = $.extend(settings, newSettings)
    },

    restoreDefaults: function() {
      settings = $.extend({}, defaults)
    }
  }

  dataConfirmModal.restoreDefaults()
  const getOptions = function(element) {
    return {
      title: element.attr('data-title') || element.attr('title') || element.attr('data-original-title'),
      text: element.attr('data-confirm'),
      method: element.attr('data-method'),
      modalClass: element.attr('data-modal-class'),
      modalCloseContent: element.attr('data-modal-close-content'),
      commit: element.attr('data-commit'),
      commitClass: element.attr('data-commit-class'),
      cancel: element.attr('data-cancel'),
      cancelClass: element.attr('data-cancel-class'),
      remote: element.attr('data-remote')
    }
  }

  const buildElementModal = function(element) {
    const options = getOptions(element)
    const modal = buildModal(options)

    modal.find('.commit').on('click', function() {
      // Call the original event handler chain
      element.get(0).click()
      modal.addClass('hidden')
      element.get(0).dispatchEvent(new Event('confirm-modal-closed'))
    })

    modal.find('.cancel, .close').on('click', function() {
      modal.addClass('hidden')
      element.get(0).dispatchEvent(new Event('confirm-modal-closed'))
    })

    return modal
  }

  const parseModalOptions = function(modal, options) {
    modal.find('.modal-title').text(options.title || settings.title)

    const body = modal.find('.c-modal__container-body')
    body.html('')

    $.each((options.text || '').split(/\n{2}/), function(i, piece) {
      body.append($('<p/>').html(piece))
    })

    const commit = modal.find('.commit')
    commit.text(options.commit || settings.commit)
    commit.addClass(options.commitClass || settings.commitClass)

    const cancel = modal.find('.cancel')
    cancel.text(options.cancel || settings.cancel)
    cancel.addClass(options.cancelClass || settings.cancelClass)

    if (options.remote) {
      commit.attr('data-dismiss', 'modal')
    }
  }

  const buildModal = function(options) {
    const id = 'confirm-modal-' + String(Math.random()).slice(2, -1)
    const xIcon = '<svg class="c-icon cursor-pointer close"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.292924 1.70714L11.8049 13.2181C12.1955 13.6086 12.8286 13.6086 13.2191 13.2181C13.6096 12.8275 13.6096 12.1944 13.2191 11.8039L1.70708 0.292863C1.31653 -0.0976448 0.68337 -0.0976173 0.292863 0.292924C-0.0976448 0.683465 -0.0976173 1.31663 0.292924 1.70714Z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M11.7211 0.297732L0.288088 11.8877C-0.0997642 12.2809 -0.0954466 12.9141 0.297732 13.3019C0.69091 13.6898 1.32406 13.6854 1.71191 13.2923L13.1449 1.70227C13.5328 1.30909 13.5284 0.67594 13.1353 0.288088C12.7421 -0.0997642 12.1089 -0.0954466 11.7211 0.297732Z" /></svg>'

    const fade = settings.fade ? 'fade' : ''
    const modalClass = options.modalClass ? options.modalClass : settings.modalClass

    const modalCloseContent = options.modalCloseContent ? options.modalCloseContent : settings.modalCloseContent
    const modalClose = '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">' + modalCloseContent + '</button>'

    const modal = $(
      '<div class="c-modal hidden" data-test-id="modal">' +
        '<div class="c-modal__container s-card">' +
          '<div class="c-modal__container-header">' +
            '<span class="modal-title"></span>' + xIcon +
          '</div>' +
          '<div class="c-modal__container-body"></div>' +
          '<div class="c-modal__container-footer">' +
            '<div class="c-button--type-tertiary mr-3 px-10 cancel">CANCEL</div>' +
            '<div class="commit" data-test-id="modal-commit">' +
          '</div>' +
        '</div>' +
      '</div>'
    )

    parseModalOptions(modal, options)
    $('body').append(modal)

    return modal
  }

  /**
   * Returns a modal already built for the given element or builds a new one,
   * caching it into the element's `confirm-modal` data attribute.
   */
  $.fn.getConfirmModal = function() {
    const element = $(this); let modal = element.data('confirm-modal')

    if (!modal) {
      modal = buildElementModal(element)
      element.data('confirm-modal', modal)
    } else {
      const options = getOptions(element)
      parseModalOptions(modal, options)
    }

    return modal
  }

  async function resetConfirm(that) {
    setTimeout(() => {
      that.dispatchEvent(new Event('confirm-modal-reset'))
      window.confirm = window_confirm
    }, 100)
  }

  if (window.Rails || $.rails) {
    /**
     * Attaches to Rails' UJS adapter's 'confirm' event, triggered on elements
     * having a `data-confirm` attribute set.
     *
     * If the modal is not visible, then it is spawned and the default Rails
     * confirmation dialog is canceled.
     *
     * If the modal is visible, it means the handler is being called by the
     * modal commit button click handler, as such the user has successfully
     * clicked on the confirm button. In this case Rails' confirm function
     * is briefly overridden, and afterwards reset when the modal is closed.
     *
     */
    const window_confirm = window.confirm

    $(document).delegate(settings.elements.join(', '), 'confirm', function(event) {
      const modal = $(this).getConfirmModal()

      if (!modal.is(':visible')) {
        this.dispatchEvent(new Event('confirm-modal-opened'))
        modal.removeClass('hidden')
        // Cancel Rails' confirmation
        return false
      } else {
        // Modal has been confirmed. Override Rails' handler
        window.confirm = function() {
          return true
        }

        resetConfirm(this)

        this.dispatchEvent(new Event('confirm-modal-confirmed'))

        return true
      }
    })
  }
})(jQuery)
